import { useState } from 'react';
import { Link } from 'react-router-dom';
import { navigation } from '../../data/siteContent';

function SiteHeader({ detailLink }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="sticky top-0 z-20 border-b border-[#18322814] bg-[rgba(244,239,230,0.78)] backdrop-blur">
      <div className="mx-auto flex w-[min(1120px,calc(100%-40px))] items-center justify-between py-4">
        <Link className="text-sm font-semibold uppercase tracking-[0.18em] text-[#163127] no-underline" to="/">
          OmsorgBygg.no
        </Link>
        {detailLink ? (
          <Link className="text-sm font-semibold text-[#355046] no-underline transition hover:text-[#163127]" to={detailLink}>
            Tilbake til oversikten
          </Link>
        ) : (
          <>
            <nav aria-label="Hovednavigasjon" className="hidden gap-6 text-sm text-[#355046] md:flex">
              {navigation.map((item) => (
                <a className="no-underline transition hover:text-[#163127]" href={item.href} key={item.href}>
                  {item.label}
                </a>
              ))}
            </nav>
            <button
              aria-controls="mobil-meny"
              aria-expanded={isMenuOpen}
              aria-label="Åpne meny"
              className="flex h-10 w-10 items-center justify-center rounded-full border border-[#1832281f] bg-[rgba(255,255,255,0.7)] text-[#163127] md:hidden"
              onClick={() => setIsMenuOpen((open) => !open)}
              type="button"
            >
              <span aria-hidden="true" className="text-lg">
                {isMenuOpen ? '✕' : '☰'}
              </span>
            </button>
          </>
        )}
      </div>
      {!detailLink && isMenuOpen ? (
        <nav
          aria-label="Mobilnavigasjon"
          className="mx-auto w-[min(1120px,calc(100%-40px))] pb-4 md:hidden"
          id="mobil-meny"
        >
          <div className="grid gap-1 rounded-2xl border border-[#18322814] bg-[rgba(255,255,255,0.8)] p-2">
            {navigation.map((item) => (
              <a
                className="rounded-xl px-4 py-3 text-sm font-semibold text-[#355046] no-underline transition hover:bg-[rgba(29,76,59,0.08)] hover:text-[#163127]"
                href={item.href}
                key={item.href}
                onClick={() => setIsMenuOpen(false)}
              >
                {item.label}
              </a>
            ))}
          </div>
        </nav>
      ) : null}
    </div>
  );
}

export default SiteHeader;